// extracted by mini-css-extract-plugin
module.exports = {"TabSelector":"TabSelector_TabSelector__3U6yQ","active":"TabSelector_active__34ilb"};